import { useMemo } from 'react';

export const usePagination = (totalPages: number, currentPage: number) => {
  const paginationItems = useMemo(() => {
    if (totalPages === 0) return [];

    const items: (number | { type: 'ellipsis'; key: string })[] = [];
    const showEllipsis = totalPages > 7;

    if (!showEllipsis) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    // 항상 첫 페이지 표시
    items.push(1);

    if (currentPage > 3) {
      items.push({ type: 'ellipsis', key: 'ellipsis-start' });
    }

    // 현재 페이지 주변 표시
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      if (!items.some((item) => typeof item === 'number' && item === i)) {
        items.push(i);
      }
    }

    if (currentPage < totalPages - 2) {
      items.push({ type: 'ellipsis', key: 'ellipsis-end' });
    }

    // 항상 마지막 페이지 표시
    if (!items.some((item) => typeof item === 'number' && item === totalPages)) {
      items.push(totalPages);
    }

    return items;
  }, [currentPage, totalPages]);

  return {
    paginationItems,
  };
};
